import React from 'react'
import util from 'meinian-package/src/utils/util'
import { PLATFORM_CONFIG_ENUM, PLATFORM_VALUE, ZK_PLATFORM_CONFIG_ENUM, ZK_DEFAULT_PLATFORM_CONFIG } from 'meinian-package/src/component/platformConfig'
import { toOriginLink } from '../../imageDetail/infoCase'

const HIDDEN_ORIGIN_LINK_PLATFORM_IDS = [
  PLATFORM_VALUE.XIAOHONGSHU,
  PLATFORM_VALUE.ZHI_XIAO_HONG,
  PLATFORM_VALUE.ZXH_ITEM,
].map(Number)

export default (props) => {
  const { platformId, children, className, style, item } = props
  const currentPlatformId = item?.childPlatformId || platformId

  const dto = item.isFromZkPlatform
    ? item[(ZK_PLATFORM_CONFIG_ENUM.get(currentPlatformId)?.dto || ZK_DEFAULT_PLATFORM_CONFIG.dto)]
    : item[PLATFORM_CONFIG_ENUM.get(currentPlatformId)?.dto] || {}

  const href = HIDDEN_ORIGIN_LINK_PLATFORM_IDS.includes(Number(currentPlatformId))
    ? null
    : toOriginLink(currentPlatformId, { ...item, ...dto })
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{ href ? <a
    onClick={() => {
      util.track('mn-origin-link', {
        module1: '卡片',
        module2: '站内款式原文',
      })
    }}
    style={style}
    href={href}
    target="_blank"
    rel="noreferrer"
    className={className}
  >{children || '跳转原文'}</a> : <span>{children}</span>}</>
}
